import {Component, Input} from '@angular/core';
import {AssistantMessageDto} from '../../../Models/Assistant/assistant-message.interface';

@Component({
  selector: 'app-assistant-message',
  templateUrl: './assistant-message.component.html',
  styleUrls: ['./assistant-message.component.scss'],
  standalone: false
})
export class AssistantMessageComponent {
  @Input() message!: AssistantMessageDto;
}
